import { DashboardConfigModel } from "./../../instance/models/instance.model";
import {
  ApplicationRouteURL,
  RoleLevel,
  WeGoConfig
} from "./../../shared/config";
import { VehicleIssue } from "./../models/dashboard-vehicle-status.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { WindowsServiceStatusModel } from "./../models/windows-service-status.model";
import { JQueryHelperService } from "./../../shared/models/jquery-helper.service";
import { AuthService } from "./../../shared/models/auth.service";
import { AdminDashboardService } from "./../models/admin-dashboard.service";
import { OnInit, Component, OnDestroy } from "@angular/core";
import { DashboardVehicleStatus } from "../models/dashboard-vehicle-status.model";
declare var google: any;
var greenIcon = require("../../../../public/images/pin/pin-green.png");
var blueIcon = require("../../../../public/images/pin/pin-blue.png");
var orangeIcon = require("../../../../public/images/pin/pin-orange.png");
var grayIcon = require("../../../../public/images/pin/pin-gray.png");
var redIcon = require("../../../../public/images/pin/pin-red.png");
var MarkerWithLabel = require("markerwithlabel")(google.maps);
var overlappingMarkerSpiderfier = require("overlapping-marker-spiderfier");

@Component({
  selector: "map",
  template: require('../views/admin-dashboard.component.html'),
  styles: [require('../models/admin-dashboard.component.css')],
  providers: [AdminDashboardService]
})
export class AdminDashboardComponent implements OnInit, OnDestroy {
  intervalHandler: NodeJS.Timer;
  filterselectedStatus: string;
  filtervehicleLocationType: any;

  dashboardConfig: DashboardConfigModel;
  urlVehicleInfo: string;
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  instanceHashId: string = "";
  companyHashId: string = "";
  svgHashId: string = "";
  vehicleLocationType: string;
  filterEnable: boolean;
  map: any;
  markerSpiderfier: any;
  infoWindow: any;
  markers: any;
  vehicleList: DashboardVehicleStatus[];
  windowsServiceStatusList: WindowsServiceStatusModel[];
  onlinePaymentServiceStatus: WindowsServiceStatusModel = new WindowsServiceStatusModel();
  vehicleIssuePriorityList: VehicleIssue[];
  selectedStatus: string;
  enableCurrentLocation: boolean;
  autoUpdateTimer: any;
  notBookedValue: string = "";
  samePositionValue: string = "";
  notBookedValueInterval: string = "";
  samePositionValueInterval: string = "";
  roleLevel = RoleLevel;

  icon: any = {
    available: {
      icon: greenIcon
    },
    unavailable: {
      icon: grayIcon
    },
    inuse: {
      icon: blueIcon
    },
    priority1: {
      icon: redIcon
    },
    priority2: {
      icon: orangeIcon
    }
  };

  constructor(
    private adminDashboardService: AdminDashboardService,
    private translateService: TranslateService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.InitDefaultValue();
    //this.UpdateMarkerOnMap();
    this.GetWindowsServiceStatus();

    this.intervalHandler = setInterval(
      () => this.GetPaymentServiceStatus(),
      WeGoConfig.ONLINE_PAYMENT_SERVICE_REFRESH_INTERVAL_SEC * 1000
    );
    this.GetPaymentServiceStatus();
  }

  OnSearch($event: any) {
    this.instanceHashId = $event.instanceHashId;
    this.companyHashId = $event.companyHashId;
    this.svgHashId = $event.svgHashId;
    this.vehicleIssuePriorityList = $event.vehicleIssuePriorityList;
    this.dashboardConfig = $event.dashboardConfig;
    this.notBookedValue = $event.notBookedValue;
    this.samePositionValue = $event.samePositionValue;
    this.notBookedValueInterval = $event.notBookedValueInterval;
    this.samePositionValueInterval = $event.samePositionValueInterval;
    console.log(this.dashboardConfig);
    this.RetriveFilter();
    this.HandleDefaultDashboardConfig();
    this.HandleAutoUpdateInterval();
    this.HandleOverLappingMarker();
    this.UpdateMarkerOnMap();
  }

  public InitDefaultValue() {
    this.markers = [];

    this.vehicleList = [];
    this.filterEnable = true;
    this.dashboardConfig = new DashboardConfigModel();
    this.HandleDefaultDashboardConfig();

    this.urlVehicleInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_INFO
    );
    console.log(this.urlVehicleInfo);
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 52.3702164, lng: 4.895168 },
      zoom: 13,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      }
    });
    this.infoWindow = new google.maps.InfoWindow();
  }

  public HandleOverLappingMarker() {
    this.markerSpiderfier = new overlappingMarkerSpiderfier(this.map, {
      keepSpiderfied: true,
      circleFootSeparation: 60,
      nearbyDistance: 50
    });

    this.markerSpiderfier.addListener("unspiderfy", (tempmarkers: any) => {
      tempmarkers.forEach((tempmarker: any) => {
        this.infoWindow.close();
      });
    });

    this.markerSpiderfier.addListener("spiderfy", (tempmarkers: any) => {
      tempmarkers.forEach((tempmarker: any) => {
        this.infoWindow.close();
      });
    });

    google.maps.event.addListener(this.map, "click", (event: any) => {
      this.infoWindow.close();
    });
  }

  public HandleDefaultDashboardConfig() {
    this.enableCurrentLocation = this.dashboardConfig.enableCurrentLocation;
    if (
      this.filtervehicleLocationType &&
      (this.filtervehicleLocationType != "CURRENT" ||
        this.enableCurrentLocation)
    ) {
      this.vehicleLocationType = this.filtervehicleLocationType;
      this.filtervehicleLocationType = null;
    } else {
      this.vehicleLocationType = this.dashboardConfig.defaultLocation;
    }
    if (this.filterselectedStatus) {
      this.selectedStatus = this.filterselectedStatus;
      this.filterselectedStatus = null;
    } else {
      this.selectedStatus = this.dashboardConfig.defaultStatus;
    }
  }

  public HandleAutoUpdateInterval() {
    if (this.autoUpdateTimer) {
      clearInterval(this.autoUpdateTimer);
    }

    let updateInterval = parseInt(this.dashboardConfig.updateIntervalInSecond);
    if (
      this.enableCurrentLocation &&
      this.vehicleLocationType == "CURRENT" &&
      isFinite(updateInterval) &&
      updateInterval >= 15
    ) {
      this.autoUpdateTimer = setInterval(
        () => this.UpdateMarkerOnMap(),
        updateInterval * 1000
      );
    }
  }

  public GetWindowsServiceStatus() {
    this.adminDashboardService.GetWindowsServiceStatus().subscribe(
      res => {
        this.windowsServiceStatusList = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ChangeVehicleLocationType(locationType: string) {
    this.vehicleLocationType = locationType;
    this.HandleAutoUpdateInterval();
    this.AddMarkers();
  }

  public FilterVehicleStatus() {
    this.AddMarkers();
  }

  public ToggleFilter() {
    this.filterEnable = !this.filterEnable;
    setTimeout(() => {
      let center = this.map.getCenter();
      google.maps.event.trigger(this.map, "resize");
      this.map.setCenter(center);
    }, 1000);
  }

  public UpdateMarkerOnMap() {
    console.log("New Vehicle Data");
    this.adminDashboardService
      .GetVehicleWithStatus(
        this.instanceHashId,
        this.companyHashId,
        this.svgHashId
      )
      .subscribe(
        res => {
          this.vehicleList = res.data;
          this.AddMarkers();
          // this.isLoading = false;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
          // this.isLoading = false;
        }
      );
  }

  public ExportVehicleStatus() {
    this.adminDashboardService
      .ExportVehicleWithStatusXls(
        this.instanceHashId,
        this.companyHashId,
        this.svgHashId
      )
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "VehicleStatus" + new Date().toISOString() + ".xlsx";
            this.authService.DownloadXlsFile(fileName, res._body);
          }
        },
        (error: any) => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public AddMarkers() {
    let filterVehicleList = this.vehicleList.filter(
      x =>
        this.selectedStatus == "ALL" ||
        this.selectedStatus.toUpperCase() == x.vehicleStatus.toUpperCase()
    );
    this.RemoveMarkers();
    filterVehicleList.forEach(element => {
      let locationType =
        this.vehicleLocationType == "CURRENT"
          ? "currentLocation"
          : "homeLocation";
      if (
        element[locationType] &&
        element[locationType]["latitude"] &&
        element[locationType]["longitude"]
      ) {
        let marker = new MarkerWithLabel({
          position: new google.maps.LatLng(
            element[locationType]["latitude"],
            element[locationType]["longitude"]
          ),
          icon: this.icon[element.vehicleStatus.toLowerCase()].icon,
          map: this.map,
          labelContent: element.licenceTag,
          labelAnchor: new google.maps.Point(32, 0),
          labelClass: "markerMapLabels", // the CSS class for the label
          labelStyle: { opacity: 0.75 }
        });

        this.markers.push(marker);
        marker.addListener("click", () =>
          this.OpenInfoWindow(this.map, marker, this.infoWindow, element)
        );
        this.markerSpiderfier.addMarker(marker);
      }
    });

    setTimeout(() => {
      this.FitMarkerToBound();
    }, 1000);
  }

  public RemoveMarkers() {
    while (this.markers.length) {
      this.markers.pop().setMap(null);
    }
  }

  private FitMarkerToBound() {
    if (this.markers && this.markers.length > 0) {
      let bound = new google.maps.LatLngBounds();
      for (var i in this.markers) {
        bound.extend(this.markers[i].getPosition());
      }
      this.map.fitBounds(bound);

      let zoomChangeBoundsListener = google.maps.event.addListenerOnce(
        this.map,
        "bounds_changed",
        (event: any) => {
          if (this.map.getZoom() > 15) {
            this.map.setZoom(15);
          }
        }
      );
      setTimeout(() => {
        google.maps.event.removeListener(zoomChangeBoundsListener);
      }, 2000);
    }
  }

  public OpenInfoWindow(
    map: any,
    marker: any,
    infoWindow: any,
    contentItems: DashboardVehicleStatus
  ) {
    let LblVehicleOwner = this.translateService.instant("LblVehicleOwner");
    let LblLicenceTag = this.translateService.instant("LblLicenceTag");
    let LblApkExpirationDateCet = this.translateService.instant(
      "LblApkExpirationDateCet"
    );
    let LblBrand = this.translateService.instant("LblBrand");
    let LblType = this.translateService.instant("LblType");
    let LblInstance = this.translateService.instant("LblInstance");
    let priorityContent = this.GeneratePriorityContent(contentItems);
    let instanceDetail =
      this.authService.GetHighestRoleLevel() <= RoleLevel.Instance
        ? `<div><b>` +
          LblInstance +
          ` : </b> ` +
          contentItems.instanceName +
          `</div>`
        : "";
    // let vehicleURL = `/#` + this.urlVehicleInfo + `;vehicleHashId=` + contentItems.vehicleHashId;
    let vehicleURL =
      `/#` + this.urlVehicleInfo + `/` + contentItems.vehicleHashId;
    let content = "";
    if (contentItems.isLinkEnable) {
      content +=
        `<div>
      <div><b>` +
        LblLicenceTag +
        ` : </b> <a href="` +
        vehicleURL +
        `">` +
        contentItems.licenceTag +
        `</a> </div>
      <div><b>` +
        LblBrand +
        ` : </b> ` +
        this.HandleEmptyValue(contentItems.brand) +
        `</div>
      <div><b>` +
        LblType +
        ` : </b> ` +
        this.HandleEmptyValue(contentItems.type) +
        `</div>
      <div><b>` +
        LblVehicleOwner +
        ` : </b> ` +
        contentItems.vehicleOwner +
        `</div>` +
        instanceDetail +
        `
      <div><b>` +
        LblApkExpirationDateCet +
        ` : </b> ` +
        this.HandleEmptyValue(contentItems.apkMaintenanceDateCETFormat) +
        `</div>
      <div>` +
        priorityContent +
        `</div>
      </div>`;
    } else {
      content +=
        `<div>
      <div><b>` +
        LblLicenceTag +
        ` : </b>` +
        contentItems.licenceTag +
        `</div>
      <div><b>` +
        LblBrand +
        ` : </b> ` +
        this.HandleEmptyValue(contentItems.brand) +
        `</div>
      <div><b>` +
        LblType +
        ` : </b> ` +
        this.HandleEmptyValue(contentItems.type) +
        `</div>
      <div><b>` +
        LblVehicleOwner +
        ` : </b> ` +
        contentItems.vehicleOwner +
        `</div>` +
        instanceDetail +
        `
      <div><b>` +
        LblApkExpirationDateCet +
        ` : </b> ` +
        this.HandleEmptyValue(contentItems.apkMaintenanceDateCETFormat) +
        `</div>
      <div>` +
        priorityContent +
        `</div>
      </div>`;
    }
    infoWindow.setContent(content);
    infoWindow.open(this.map, marker);
  }

  public GeneratePriorityContent(contentItems: DashboardVehicleStatus) {
    let LblPriority = this.translateService.instant("LblPriority");
    let content = `<br><div><b>` + LblPriority + ` 1</b></div>`;
    content += `<table><tbody>`;
    contentItems.listOfVehicleIssue
      .filter(x => x.priority == "PRIORITY1")
      .forEach(item => {
        content +=
          `<tr>` +
          `<td style="width: 235px">` +
          this.GetLabelFromType(item.type) +
          `</td>` +
          (item.issueFound
            ? `<td><i class="fa fa-times text-danger" aria-hidden="true"></i>&nbsp;</td>`
            : `<td><i class="fa fa-check text-success" aria-hidden="true"></i>&nbsp;</td>`) +
          `</tr>`;
      });

    content += `</tbody></table>`;

    content += `<br><div><b>` + LblPriority + ` 2</b></div>`;
    content += `<table><tbody>`;
    contentItems.listOfVehicleIssue
      .filter(x => x.priority == "PRIORITY2")
      .forEach(item => {
        content +=
          `<tr>` +
          `<td style="width: 235px">` +
          this.GetLabelFromType(item.type) +
          `</td>` +
          (item.issueFound
            ? `<td><i class="fa fa-times text-danger" aria-hidden="true"></i>&nbsp;</td>`
            : `<td><i class="fa fa-check text-success" aria-hidden="true"></i>&nbsp;</td>`) +
          `</tr>`;
      });

    content += `</tbody></table>`;

    return content;
  }

  public HandleEmptyValue(value: any) {
    let LblNA = this.translateService.instant("LblNA");
    if (value != null && value) return value;
    else return LblNA;
  }

  private GetPriorityLegend(
    listOfVehicleIssue: VehicleIssue[],
    priority: string
  ) {
    if (listOfVehicleIssue) {
      return listOfVehicleIssue.filter(x => x.priority == priority);
    }
  }

  private GetLabelFromType(issueType: string) {
    switch (issueType) {
      case "DamageReported":
        return this.translateService.instant("LblTypeDamage");
      case "APKMaintananceScheduled":
        return this.translateService.instant("LblTypeMaintenance");
      case "OutSideGeofence":
        return this.translateService.instant("LblOutsideGeofence");
      case "VehicleSamePosition":
        return this.translateService.instant("LblTypeOnSamePosition", [
          this.samePositionValue == "" ? "0" : this.samePositionValue,
          this.samePositionValueInterval
        ]);
      case "VehicleNotReturn":
        return this.translateService.instant("LblTypeNotReturn");
      case "VehicleNotBooked":
        return this.translateService.instant("LblTypeNotBooked", [
          this.notBookedValue == "" ? "0" : this.notBookedValue,
          this.notBookedValueInterval
        ]);
      case "CleaningRequired":
        return this.translateService.instant("LblCleaning");
      case "RefuelingRequired":
        return this.translateService.instant("LblRefueling");
      case "LowBattery":
        return this.translateService.instant("LblLowBattery");
      case "LowCharge":
        return this.translateService.instant("LblLowCharge");
      case "CommunicationProblem":
        return this.translateService.instant("LblCommunicationProblem");
      case "InvalidTagUsed":
        return this.translateService.instant("LblInvalidTagUsed");
      default:
        return this.translateService.instant("LblNA");
    }
  }

  private RetriveFilter() {
    var filter = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      null
    );

    if (filter) {
      this.filtervehicleLocationType = filter["vehicleLocationType"];
      this.filterselectedStatus = filter["selectedStatus"];
    }
  }

  public GetPaymentServiceStatus() {
    this.adminDashboardService.GetPaymentServiceStatus().subscribe(
      res => {
        this.onlinePaymentServiceStatus = res.data;
      },
      error => {
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.autoUpdateTimer) {
      clearInterval(this.autoUpdateTimer);
    }

    if (this.intervalHandler) {
      clearInterval(this.intervalHandler);
    }

    this.authService.SaveToStorage(this.constructor.name + "_model", {
      vehicleLocationType: this.vehicleLocationType,
      selectedStatus: this.selectedStatus
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/components/admin-dashboard.component.ts